
export const appsettings = {
    routes : {
      CreditCards_URL: (window.location.href.toString().indexOf("wpayments") !== -1 ? "https://apiwest.aims360.rest/customers" : "https://apieast.aims360.rest/customers"),
        PayInvoice_Base_URL: (window.location.href.toString().indexOf("wpayments") !== -1 ? "https://aims360-fn-w-invoicemanagement.azurewebsites.net" : "https://aims360-fn-e-invoicemanagement.azurewebsites.net"),
        Order_Base_URL: (window.location.href.toString().indexOf("wpayments") !== -1 ? "https://aims360-fn-w-ordermanagement.azurewebsites.net/" : "https://aims360-fn-e-ordermanagement.azurewebsites.net/")

    },
    constants: {
        invoice_base_url_version: ("v1.0"),
        invoice_base_param1: ("/invoice/"),
        invoice_base_param2: ("/payinvoice/")
    }
}


//CreditCards_URL: (window.location.href.toString().indexOf("wpayments") !== -1 ? "https://apiwest.aims360.rest/customers" : "https://apieast.aims360.rest/customers"),

// CreditCards_URL: (window.location.href.toString().indexOf("wpayments") !== -1 ? "https://apiwest.aims360.rest/customers" : "https://apieast.aims360.rest/customers"),
// PayInvoice_Base_URL: (window.location.href.toString().indexOf("wpayments") !== -1 ? "https://aims360-fn-w-invoicemanagement.azurewebsites.net" : "https://aims360-fn-e-invoicemanagement.azurewebsites.net")
// CreditCards_URL: "https://aims360-fn-customermanagementtest.azurewebsites.net",  
//       PayInvoice_Base_URL: "https://aims360-fn-invoicetest.azurewebsites.net",
//       Order_Base_URL: "https://aims360-fn-ordermanagementtest.azurewebsites.net"
//https://wpayments.aims360.rest
//https://epayments.aims360.rest


